import { toast } from "react-semantic-toasts";

import {
    REPORTS_RANGE_TYPE,
    REPORTS_FIRST_PERIOD,
    REPORTS_SECOND_PERIOD,
    REPORTS_FIRST_DATA,
    REPORTS_SECOND_DATA,
    REPORTS_LOADING,
} from "../constants";
import { makePrivateApiCall } from "utilities/dist/api";

export const setRangeType = rangeType => dispatch => {
    dispatch({
        type: REPORTS_RANGE_TYPE,
        payload: rangeType,
    });
};

export const setFirstDateRange = dateRange => dispatch => {
    dispatch({
        type: REPORTS_FIRST_PERIOD,
        payload: dateRange,
    });
};

export const setSecondDateRange = dateRange => dispatch => {
    dispatch({
        type: REPORTS_SECOND_PERIOD,
        payload: dateRange,
    });
};

export const loadStats =
    ({ from, to }, order) =>
    dispatch => {
        dispatch({
            type: REPORTS_LOADING,
            payload: true,
        });

        return makePrivateApiCall({
            url: "/company/stats",
            method: "get",
            params: {
                from,
                to,
            },
        })
            .then(res => {
                if (res.data) {
                    const actionType = order === 1 ? REPORTS_FIRST_DATA : REPORTS_SECOND_DATA;

                    dispatch({
                        type: actionType,
                        payload: res.data,
                    });
                }
            })
            .catch(() => {
                dispatch({
                    type: REPORTS_LOADING,
                    payload: false,
                });

                toast({
                    description: "Error occurred while getting stats.",
                    time: 3000,
                    type: "error",
                    icon: "warning sign",
                    title: "Error",
                });
            });
    };
